import { __assign } from 'tslib';
import React, { useCallback } from 'react';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import { PushPinIcon } from '@panwds/icons';
import { classNames } from '@panwds/react-ui';
import { useTableLayoutHeaderTitleEnabled, useTableLayoutEnabled } from '../TableLayout/TableLayout.esm.js';
import 'uuid';
import '../TableContext/TableContext.esm.js';
import '../TableContext/TableProvider.esm.js';
import { useIntl } from 'react-intl';
import { SortButton } from './SortButton.esm.js';
import { DragHandle } from './DragHandle.esm.js';

var OrderableHeaderCell = SortableElement(function (props) { return (React.createElement("div", __assign({}, props))); });
var Handle = SortableHandle(DragHandle);
function HeaderCell(_a) {
    var _b = _a.uppercaseHeaderColumns, uppercaseHeaderColumns = _b === void 0 ? false : _b, column = _a.column, index = _a.index, _c = _a.orderable, orderable = _c === void 0 ? false : _c, _d = _a.lastCell, lastCell = _d === void 0 ? false : _d, _e = _a.lastGroup, lastGroup = _e === void 0 ? false : _e, _f = _a.stickyLeft, stickyLeft = _f === void 0 ? false : _f, _g = _a.stickyRight, stickyRight = _g === void 0 ? false : _g;
    var resizerProps = column.canResize ? column.getResizerProps() : null;
    var tableLayoutHeaderTitleEnabled = useTableLayoutHeaderTitleEnabled();
    var tableLayoutEnabled = useTableLayoutEnabled();
    var intl = useIntl();
    /* istanbul ignore next */
    var onMouseDown = useCallback(function (e) {
        if (resizerProps) {
            var onMouseDown_1 = resizerProps.onMouseDown;
            e.preventDefault();
            onMouseDown_1(e);
        }
    }, [resizerProps]);
    var sortDirection = column.isSortedDesc
        ? "descending"
        : column.isSorted
            ? "ascending"
            : "none";
    var className = classNames("tw-group", "tw-box-border tw-relative tw-text-xs tw-py-1.5 tw-bg-white tw-h-8 dark:tw-bg-blue-steel-1000 dark:tw-text-blue-steel-300 tw-px-4", uppercaseHeaderColumns && "tw-uppercase", lastCell && "tw-flex-grow", tableLayoutHeaderTitleEnabled &&
        "tw-border-solid tw-border-gray-300 tw-border-l-0 tw-border-r-0 tw-border-t-0 tw-border-b dark:tw-border-blue-steel-800 tw-font-bold tw-py-2", !tableLayoutHeaderTitleEnabled &&
        "tw-border-solid tw-border-gray-300 tw-border-0 tw-border-b dark:tw-border-blue-steel-800 tw-font-bold tw-py-1.5", !lastGroup &&
        !lastCell &&
        !stickyLeft &&
        !stickyRight &&
        !tableLayoutHeaderTitleEnabled &&
        "group-hover:tw-border-r", !lastGroup &&
        !lastCell &&
        !stickyLeft &&
        !stickyRight &&
        !tableLayoutEnabled &&
        "group-hover:tw-border-r", !lastGroup &&
        !lastCell &&
        !stickyLeft &&
        !stickyRight &&
        tableLayoutHeaderTitleEnabled &&
        tableLayoutEnabled &&
        "group-hover:tw-border-r", !lastCell &&
        tableLayoutHeaderTitleEnabled &&
        stickyLeft &&
        "group-hover:tw-border-r", lastGroup && "last:tw-border-r-0");
    var Comp = orderable ? OrderableHeaderCell : "div";
    return (React.createElement(React.Fragment, null,
        React.createElement(Comp, __assign({ "aria-sort": sortDirection, "data-table-column-id": column.id }, column.getHeaderProps(), { className: className, index: index }),
            React.createElement("div", { className: "tw-flex tw-leading-5" },
                React.createElement("div", { className: "tw-truncate" }, column.render("Header")),
                React.createElement(SortButton, { column: column }),
                (stickyLeft || stickyRight) && (React.createElement("button", { className: "tw-flex tw-items-center tw-ml-2 tw-border-none tw-bg-transparent tw-m-0 tw-p-0 tw-opacity-0 group-hover:tw-opacity-100 focus:tw-opacity-100 focus:outline-none focus-visible:ring" },
                    React.createElement(PushPinIcon, { size: "xs", className: "tw-text-gray-400 dark:tw-text-dark-bg" }))),
                orderable && (React.createElement("div", { className: "tw-flex-auto tw-flex tw-justify-end" },
                    React.createElement(Handle, { label: intl.formatMessage({ id: "U/boik", defaultMessage: [{ type: 0, value: "Drag to reorder" }] }), addClassName: "tw-flex tw-items-center tw-border-none tw-bg-transparent tw-opacity-0 group-hover:tw-opacity-100 focus:tw-opacity-100 tw-text-gray-600 dark:tw-text-dark-bg" })))),
            resizerProps && !lastCell && (React.createElement("div", __assign({}, resizerProps, { onMouseDown: onMouseDown, className: "tw-absolute tw-right-0 tw-h-full tw-w-2 tw-top-0" }))))));
}

export { HeaderCell };
//# sourceMappingURL=HeaderCell.esm.js.map
